
import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import "../_components/antd.css";
import { Table, Tooltip } from "antd";
import {
  showTotal,
  onShowSizeChange,
  itemRender,
} from "../_components/paginationfunction";
//import Data from "../assets/jsons/vendors";
import api from "../api/api"
import { useAuth } from "../context/AuthContext";
import BookingMobile from "./BookingMobile";
import * as Icon from "react-feather";
import { title } from "process";
import BookEmployerBiodataShared from "../employers/BookEmployerBiodataShared";
import CreateBooking from "./CreateBooking";
import ConfirmModal from "./ConfirmModal";
import { useTranslation } from "react-i18next";
import EditBooking from "./EditBooking";
import DeleteModal from "./DeleteModal";
import { Link } from "react-router-dom";

const Booking = () => {
  const { t } = useTranslation();
  const {user} = useAuth()


  const [menu, setMenu] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const [error, setError] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [isAccepted, setIsAccepted] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const [data, setData] = useState([]);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);


  const fetchData = async (page = 1) => {
    //{loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }

    setLoadingForm(true)
    setError(null)


    try {

      //if(!user.token) return
      const response = await api.get("/booking/"  + `?page=${page}`);

      console.log("Res:", response);

      // Handle success based on status code
      if (response.status === 200) {
        console.log("Form submitted successfully!");
        console.log(response.response)
        if (Array.isArray(response.data.results)) {

          //the prop children is causing error on table
          const updatedData = response.data.results.map(({ children, ...rest }) => ({
            enfants: children, // Rename 'children' to 'enfants'
            ...rest,
          }));

          setData(updatedData)
          setNextPage(response.data.next);
          setPrevPage(response.data.previous);
          setCount(response.data.count);
        } else {
          console.error("Data is not an array:", response.data.results);
          setError(response.status)
        }

      } 

    } catch (error) {
      console.error("API Error:", error);

      if (error.response) {
        // The request was made and the server responded with a status code
        console.log("Error Status:", error.response.status);
        const responseCode = error.response.data.detail ? error.response.data.detail : "Unknown";
      
        setError(responseCode)
        setError(error.response.status);
      } else if (error.request) {
        // The request was made but no response was received
        console.log("No response received:", error.request);
        setError("No response from server");
      } else {
        // Something happened in setting up the request
        console.log("Error setting up request:", error.message);
        setError("Request setup error");
      }
      

    } finally {


      setLoadingForm(false);
    }
  }

  const handleAccept = (record) => {
    setSelectedData(record);
    setIsAccepted(true);
  };
  const handleReject = (record) => {
    setSelectedData(record);
    setIsAccepted(false);
  };

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  useEffect(() => {

    fetchData()
  }, [])

  const handlePageChange = (page) => {
    if (page < 1 || page > Math.ceil(count / 10)) return; // Prevent invalid page numbers

    setCurrentPage(page);
    fetchData(page);
  };





  const columns = [
    {
      title: t("Action"),
      dataIndex: "Action",
      render: (_, record) => {

        return (
          <div className="d-flex align-items-center gap-2">
          {
            user.type == "agency" && (
              <>
                {record.status == "Pending" && (
                  <>
                    <button 
                      type="button" 
                      className="btn btn-greys" 
                      data-bs-toggle="modal" 
                      data-bs-target="#book_biodata_dialog" 
                      onClick={() => { setSelectedData(record); setIsAccepted(true) }}
                    >
                      <Icon.CheckCircle /> {t("Accept")}
                    </button>
                    <button 
                      type="button" 
                      className="btn btn-greys" 
                      data-bs-toggle="modal" 
                      data-bs-target="#book_biodata_dialog" 
                      onClick={() => { setSelectedData(record); setIsAccepted(false) }}
                    >
                      <Icon.XCircle /> {t("Decline")}
                    </button>
                  </>
                )}

                {(record.status == "Created By Agency" || record.status == "Pending") && (
                  <>
                    <button
                      type="button"
                      className="btn btn-primary"
                      data-bs-toggle="modal"
                      data-bs-target="#edit_booking_dialog"
                      onClick={() => { setSelectedData(record); setIsEditOpen(true); } }
                    >
                      <Icon.Edit /> {t("Edit")}
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger"
                      data-bs-toggle="modal"
                      data-bs-target="#deleteModal"
                      onClick={() => { setSelectedData(record);}}
                    >
                      <Icon.Trash2 /> {t("Delete")}
                    </button>
                  </>
                )}
              </>
            )
          }

          {
            user.type == "supplier" && (
              <>
                  {
                      (record.status == 'Approved By Agency' || record.status == 'Created By Agency') && (
                    <>
                      <button 
                        type="button" 
                        className="btn btn-greys" 
                        data-bs-toggle="modal" 
                        data-bs-target="#book_biodata_dialog" 
                        onClick={() => { setSelectedData(record); setIsAccepted(true) }}
                      >
                        <Icon.CheckCircle /> {t("Accept")}
                      </button>
                      <button 
                        type="button" 
                        className="btn btn-greys" 
                        data-bs-toggle="modal" 
                        data-bs-target="#book_biodata_dialog" 
                        onClick={() => { setSelectedData(record); setIsAccepted(false) }}
                      >
                        <Icon.XCircle /> {t("Decline")}
                      </button>
                    </>
                  )
                }

                {
                  record.status == "Created By Supplier" && (
                    <>
                      <button
                        type="button"
                        className="btn btn-primary"
                        data-bs-toggle="modal"
                        data-bs-target="#edit_booking_dialog"
                        onClick={() => { setSelectedData(record); setIsEditOpen(true); }}
                      >
                        <Icon.Edit /> {t("Edit")}
                      </button>

                      <button
                        type="button"
                        className="btn btn-danger"
                        data-bs-toggle="modal"
                        data-bs-target="#deleteModal"
                        onClick={() => { setSelectedData(record); }}
                      >
                        <Icon.Trash2 /> {t("Delete")}
                      </button>
                    </>
                  )
                }

              </>
            )
          }
          </div>
        )

      },
      //sorter: (a, b) => a.Action.length - b.Action.length,
    },
    ...(user.type === "agency" ? [{
      title: t("Contracts and Aggreements"),
      render: (_, record) => <Link to={`/booking/external-forms/${record.id}/${record.booking_id}`}>Contracts and Aggreements</Link>,
    }] : []),
    {
      title: t("Status"),
      dataIndex: "status",
      render: (_,record) => (
        <div>
          {(() => {
              if (record.status === 'Pending') {
                return <span className="btn" style={{ backgroundColor: "lightgrey", width: 200, textWrap:"wrap" }}>Pending</span>;
              } else if (record.status === 'Approved By Agency' || record.status === 'Approved By Supplier') {
                return <span className="btn" style={{ backgroundColor: "lightskyblue", width: 200, textWrap:"wrap" }}>{t(record.status)}</span>;
              } else if (record.status === 'Rejected By Agency' || record.status === 'Rejected By Supplier') {
                return <span className="btn" style={{ backgroundColor: "lightsalmon", width: 200, textWrap:"wrap" }}>{t(record.status)}</span>;
              } else if (record.status === 'Created By Supplier' || record.status === 'Created By Agency') {
                return <span className="btn" style={{ backgroundColor: "lightblue", width: 200, textWrap:"wrap"}}>{t(record.status)}</span>;
              }
              else {
                return <span className="btn btn-secondary" style={{ width: 200, textWrap:"wrap" }}>{t(record.status)}</span>;
              }
          })()}
        </div>
      )
    },
    {
      title: t("Biodata Name"),
      dataIndex: "name",
      render: (_, record) => {
        return record.code + ' - '+record.name
      },
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
    },
    {
      title: t("Vendor Name"),
      dataIndex: "supplier_name",
      sorter: (a, b) => (a.supplier_name || '').localeCompare(b.supplier_name || ''),
    },
    {
      title: t("Agency Name"),
      dataIndex: "agency_name",
      sorter: (a, b) => (a.agency_name || '').localeCompare(b.agency_name || ''),
    },
    {
      title: t("Employer Name"),
      dataIndex: "employer_name",
      sorter: (a, b) => (a.employer_name || '').localeCompare(b.employer_name || ''),
    },
    {
      title: t("Agency Note"),
      dataIndex: "agency_note",
      sorter: (a, b) => a.agency_note.length - b.agency_note.length,
    },
    {
      title: t("Supplier Note"),
      dataIndex: "supplier_note",
      sorter: (a, b) => a.supplier_note.length - b.supplier_note.length,
    }

  ];


  const isMobileDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
  };

  useEffect(() => {
      const handleResize = () => {
          setScreenWidth(window.innerWidth);
      };

      // Add event listener for resizing
      window.addEventListener("resize", handleResize);

      // Cleanup event listener on component unmount
      return () => {
          window.removeEventListener("resize", handleResize);
      };
  }, []);




  return (


    <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
      <Header onMenuClick={() => toggleMobileMenu()} />
      <Sidebar />

      <div className="page-wrapper">
        {(loadingForm || error) ? (
          <div style={{ textAlign: "center", margin: "10em" }}>
            {loadingForm && <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: "4em" }} />}
            {error && (
              <div className="alert alert-danger alert-dismissible fade show" role="alert">
                <strong>Error!</strong> {error}
                {/*<button onClick={fetchData} className="btn btn-danger btn-sm ms-3">
                  Try Again
                </button>*/}
              </div>
            )}
          </div>
        ) : (
             <>

              <div className="content container-fluid">
                {/* Page Header */}
                <div className="page-header">
                  <div className="content-page-header ">
                    <h5>{t("Booking")}</h5>
                        <div className="list-btn">
                          <ul className="filter-list">
                            <li>
                              <a
                                className="btn btn-primary"
                                href="#"
                                data-bs-toggle="modal"
                                data-bs-target="#create-booking"
                                onClick={() => setIsCreateOpen(true)}
                              >
                              <i
                                className="fa fa-plus-circle me-2"
                                aria-hidden="true"
                              />
                              {t("Create")}
                              </a>
                            </li>
                          </ul>
                        </div>
                  </div>
                </div>
                
                {successMessage && (
                  <div className="alert alert-success">{successMessage}</div>
                )}
               
                {data.length === 0 && (
                  <div className="text-center mt-5 py-5">
                    <div className="mb-4">
                      <div className="mb-3">
                        <i className="fas fa-calendar-check text-muted" style={{fontSize: '4rem', opacity: 0.3}}></i>
                      </div>
                      <h4 className="text-muted mb-2">{t("No Bookings Available")}</h4>
                      <p className="text-muted mb-4">{t("Booking is when one of your biodata is booked")}</p>
                    </div>
                    <div className="d-flex gap-3 justify-content-center flex-wrap">
                      <a
                        className="btn btn-primary px-4 py-2 rounded-pill shadow-sm"
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#create-booking"
                        onClick={() => setIsCreateOpen(true)}
                      >
                        <i className="fas fa-plus me-2"></i>
                        {t("Create a booking")}
                      </a>
                    </div>
                  </div>
                )}

                <div className="row">
                  <div className="col-sm-12">
                    {isMobileDevice() || screenWidth <= 576 ? (
                      <>
                        <BookingMobile  handlePageChange={handlePageChange} currentPage={currentPage} nextPage={nextPage} prevPage={prevPage} count={count} data={data} screenWidth={screenWidth} onAccept={handleAccept} onReject={handleReject} />
                      </>
                    ) : (
                      <div className=" card-table">
                        <div className="card-body vendors">
                          <div className="table-responsive table-hover table-striped">
                            <Table
                              pagination={{
                                  total: count,
                                  current: currentPage,
                                  showTotal: (length,range) => showTotal(t,length, range),
                                  itemRender:  (page, type, originalElement) => itemRender(t, handlePageChange, currentPage, prevPage, nextPage, page, type, originalElement),
                                  onShowSizeChange: onShowSizeChange,
                              
                              }}
                              columns={columns}
                              dataSource={data}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            
          </>
        )}
      </div>

       <BookEmployerBiodataShared biodata={selectedData} isAccepted={isAccepted} fetchData={fetchData}/>
       <ConfirmModal biodata={selectedData} isAccepted={isAccepted} fetchData={fetchData} />
       <CreateBooking onRefresh={fetchData} isOpen={isCreateOpen}  />
       <EditBooking selectedData={selectedData} onRefresh={fetchData} isOpen={isEditOpen} />
      <DeleteModal biodata={selectedData} fetchData={fetchData} />
      </div>
  );
};

export default Booking;
